import { createAction, props } from '@ngrx/store';
import { HttpError } from '@rd/types';
import { RewardsProgramPreference } from '@rd/types/rewards_program.type';

export const GetRewardsProgramPreference = createAction(
  '[REWARDS PROGRAM] Get rewards program preference',
);
export const GetRewardsProgramPreferenceFail = createAction(
  '[REWARDS PROGRAM] Get rewards program preference fail',
  props<{ error: HttpError }>(),
);
export const GetRewardsProgramPreferenceSuccess = createAction(
  '[REWARDS PROGRAM] Get rewards program preference success',
  props<{ rewardsProgramPreference: RewardsProgramPreference }>(),
);

export const CreateRewardsProgramPreference = createAction(
  '[REWARDS PROGRAM] Create rewards program preference',
  props<{ rewardsProgramId: string }>(),
);
export const CreateRewardsProgramPreferenceFail = createAction(
  '[REWARDS PROGRAM] Create rewards program preference fail',
  props<{ error: HttpError }>(),
);

export const CreateRewardsProgramPreferenceSuccess = createAction(
  '[REWARDS PROGRAM] Create rewards program preference success',
  props<{ rewardsProgramPreference: RewardsProgramPreference }>(),
);
